import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Code', 'countryCode', true, 'asc', 'left'),
  new TableColumn('Description', 'countryDesc', true, 'asc', 'left'),
  new TableColumn('Nationality', 'nationality', true, 'asc', 'left'),
  new TableColumn('Calling', 'callingCode', true, 'asc', 'left'),
  new TableColumn('GST Rate', 'gstRate', true, 'asc', 'right'),
  new TableColumn('Active', 'deleted', true, 'asc', 'centered'),
  new TableColumn('', 'action', false, 'desc', 'centered')
]

export { Columns }
